import Content from './Content'

import './style.scss'

export { Content }
export default Content
